module.exports = __webpack_public_path__ + "static/media/Paired edges.94854097.svg";